var types = {
	ProgramDetails: {
		id: "H256",
		static_pages: "u32",
		persistent_pages: "BTreeMap<u32, Vec<u8>>",
		code_hash: "H256",
		nonce: "u64"
	},
	DebugData: {
		dispatch_queue: "Vec<QueuedDispatch>",
		programs: "Vec<ProgramDetails>"
	}
};
var typesDebug = {
	types: types
};

export { typesDebug as default, types };
